import React from 'react';
import { MAX_MULTI_ACCOUNTS_TO_SHOW, PROFILE_STYLES } from '../../constants';
import Heading from '../../../../generic-components/Heading';
import { IBusiness } from '../../../../types';
import { InitialsCircle } from '../../../../components/InitialsCircle';

export interface IAdditionalBusiness {
  customerExternalId: string;
  name: string;
  initials: string;
  ein?: string;
  businessType: string;
}

interface IProps {
  businessList: any;
}

export const ProfilesRender = ({ businessList }: IProps) => (
  <div className={PROFILE_STYLES.ACCOUNT_SWITCHER_TRIGGER.PROFILES.WRAPPER}>
    {businessList.length > MAX_MULTI_ACCOUNTS_TO_SHOW ? (
      <div className={PROFILE_STYLES.ACCOUNT_SWITCHER_TRIGGER.PROFILES.LONG_LIST_INDICATOR}>
        <Heading
          title={`+${MAX_MULTI_ACCOUNTS_TO_SHOW}`}
          className={PROFILE_STYLES.ACCOUNT_SWITCHER_TRIGGER.PROFILES.LONG_LIST_TITLE}
        />
      </div>
    ) : null}
    {businessList.slice(0, MAX_MULTI_ACCOUNTS_TO_SHOW).map((b: IAdditionalBusiness) => (
      <InitialsCircle
        key={b.customerExternalId}
        business={b as IBusiness}
        circleWrapperClassName={PROFILE_STYLES.ACCOUNT_SWITCHER_TRIGGER.PROFILES.PROFILE_ITEM}
        initialsClassName={PROFILE_STYLES.ACCOUNT_SWITCHER_TRIGGER.PROFILES.PROFILE_ITEM_TITLE_TRIGGER}
      />
    ))}
  </div>
);
